<template>
    <vue-page-transition name="fade">
        <router-view></router-view>
    </vue-page-transition>
</template>

<script>
    export default {
        data() {
            return {}
        },
        created() {
            this.$store.dispatch('initApp', this.$ApiClient);
        }
    }
</script>

<style lang="scss">
    @import "./assets/scss/_customFramework";
    @import "./assets/scss/main.scss";

</style>